// extracted by mini-css-extract-plugin
module.exports = {"window":"Window_window_2tX0u","content":"Window_content_1Cmqo","header":"Window_header_zVL8U","footer":"Window_footer_3qcm0"};